// extracted by mini-css-extract-plugin
export default {"imageContainer":"banner_imageContainer__P6gIY","fullView":"banner_fullView__+oW3x","shimmer":"banner_shimmer__Xqfe+"};